import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Box,
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface Sprint {
  id: string;
  sprintNumber: string;
  status: string;
  startDate?: string;
  endDate?: string;
}

interface SprintSelectionDialogProps {
  open: boolean;
  onClose: () => void;
  onContinue: (sprintId: string) => void;
  sprints: Sprint[];
  loading?: boolean;
}

const SprintSelectionDialog: React.FC<SprintSelectionDialogProps> = ({
  open,
  onClose,
  onContinue,
  sprints,
  loading = false,
}) => {
  const { t } = useTranslation(["bugherd"]);
  const [selectedSprint, setSelectedSprint] = useState<string>("");

  const handleContinue = () => {
    if (selectedSprint) {
      onContinue(selectedSprint);
    }
  };

  const handleClose = () => {
    setSelectedSprint("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6" fontWeight={600}>
          {t("Select Sprint for Retrospective")}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {t("Choose a completed sprint to start a retrospective")}
          </Typography>
          <FormControl fullWidth>
            <InputLabel id="sprint-select-label">
              {t("Sprint")}
            </InputLabel>
            <Select
              labelId="sprint-select-label"
              value={selectedSprint}
              label={t("Sprint")}
              onChange={(e) => setSelectedSprint(e.target.value)}
              disabled={loading}
            >
              {sprints.map((sprint) => (
                <MenuItem key={sprint.id} value={sprint.id}>
                  {sprint.sprintNumber}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 1 }}>
        <Button onClick={handleClose} variant="outlined">
          {t("Cancel")}
        </Button>
        <Button
          onClick={handleContinue}
          variant="contained"
          disabled={!selectedSprint || loading}
        >
          {t("Continue")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SprintSelectionDialog;
